export default "__VITE_ASSET__C5X5zcRd__"